import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isNativePlatform } from '../../utils/mediaPicker';

export default function CapacitorAppHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isNativePlatform()) return;

    let isMounted = true;

    const setupCapacitor = async () => {
      try {
        // Dynamically import Capacitor plugins to prevent SSR/Web bundle issues
        const { StatusBar, Style } = await import('@capacitor/status-bar');
        const { SplashScreen } = await import('@capacitor/splash-screen');
        const { App } = await import('@capacitor/app');

        if (!isMounted) return;

        // 1. Configure Status Bar
        try {
          await StatusBar.setStyle({ style: Style.Dark });
          await StatusBar.setBackgroundColor({ color: '#0b0f19' });
        } catch (e) {
          console.log('StatusBar not available:', e.message);
        }

        // 2. Hide Splash Screen after React mounts
        try {
          await SplashScreen.hide();
        } catch (e) {
          console.log('SplashScreen not available:', e.message);
        }

        // 3. Native Android Back Button Navigation
        try {
          App.addListener('backButton', ({ canGoBack }) => {
            if (location.pathname === '/' || location.pathname === '/login' || location.pathname === '/dashboard') {
              App.exitApp();
            } else {
              navigate(-1);
            }
          });
        } catch (e) {
          console.log('App backButton listener error:', e.message);
        }

      } catch (err) {
        console.warn('Capacitor native initialization notice:', err.message);
      }
    };

    setupCapacitor();

    return () => {
      isMounted = false;
    };
  }, [navigate, location]);

  return null;
}
